import {LINKS} from '@/const';

export const SUPPORT_CHANNEL = ['banxa', 'koinal', 'simplex', 'coinify', 'moonpay', 'mercuryo', 'advcash'];
export const SPECIAL_FIATS = ['USD', 'EUR', 'GBP', 'JPY'];

export const CHANNEL_LINK = {
  banxa: {
    link: 'https://banxa.com/terms-of-use-agreement/',
    email: 'support.banxa.com',
  },
  koinal: {
    link: 'https://www.koinal.io/terms-and-conditions',
    email: 'support-checkout@koinal.io',
  },
  simplex: {
    link: 'https://www.simplex.com/terms-of-use/',
    email: 'support@simplex.com',
  },
  coinify: {
    link: 'https://coinify.com/legal/',
    email: 'Coinify',
  },
  moonpay: {
    link: 'https://www.moonpay.io/terms_of_use',
    email: 'support@moonpay.io',
  },
  mercuryo: {
    link: 'https://mercuryo.io/privacy/',
    email: 'support@mercuryo.io',
  },
  advcash: {
    link: 'https://advcash.com/en/agreement',
    email: 'support@advcash.com',
  },
  transak: {
    link: 'https://transak.com/terms-of-service',
    email: 'support@transak.com',
  },
};

export const MULTILANG_LINKS = {
  [LINKS.SUPPORT_DO_YOUR_OWN_RESEARCH]: {
    ja: '/ja/academy/dyordo-your-own-research%E3%83%BC%E8%87%AA%E5%88%86%E3%81%A7%E8%AA%BF%E3%81%B9%E3%82%8B%E6%96%B9%E6%B3%95%E5%8C%85%E6%8B%AC%E7%9A%84%E3%81%AA%E3%82%AC%E3%82%A4%E3%83%89',
  },
  [LINKS.SUPPORT_DOGECOIN]: {
    ja: '/ja/academy/%E3%83%89%E3%83%83%E3%82%B8%E3%82%B3%E3%82%A4%E3%83%B3%E3%81%A8%E3%81%AF-%E6%9A%97%E5%8F%B7%E9%80%9A%E8%B2%A8%E3%81%A7%E6%9C%80%E3%82%82%E4%BE%A1%E5%80%A4%E3%81%AE%E3%81%82%E3%82%8B%E3%82%B8%E3%83%A7%E3%83%BC%E3%82%AF',
    ru: '//ru/academy/%D0%A7%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-dogecoin-%D0%A1%D0%B0%D0%BC%D0%B0%D1%8F-%D0%B4%D0%BE%D1%80%D0%BE%D0%B3%D0%B0%D1%8F-%D0%BA%D1%80%D0%B8%D0%BF%D1%82%D0%BE%D0%B2%D0%B0%D0%BB%D1%8E%D1%82%D0%B0-%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%BD%D0%B0%D1%8F-%D0%BD%D0%B0-%D0%BE%D1%81%D0%BD%D0%BE%D0%B2%D0%B5-%D0%BC%D0%B5%D0%BC%D0%B0',
    es: '/es/academy/que-es-dogecoin',
    tr: '/tr/academy/dogecoin-son-dakika',
  },
  [LINKS.SUPPORT_BITCOIN]: {
    ja: '/ja/academy/%E3%83%93%E3%83%83%E3%83%88%E3%82%B3%E3%82%A4%E3%83%B3%E3%81%A8%E3%81%AF',
    de: '/de/academy/was-ist-bitcoin',
    ru: '/ru/academy/%D0%A7%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-%D0%91%D0%B8%D1%82%D0%BA%D0%BE%D0%B8%D0%BD',
    es: '/es/academy/que-es-bitcoin-la-primera-criptodivisa-del-mundo',
    tr: '/tr/academy/what-is-bitcoin',
    fr: '/fr/academy/quest-ce-que-bitcoin',
  },
  [LINKS.SUPPORT_BUY_WITH_BITCOIN]: {
    ja: '/ja/blogs/2021%E5%B9%B4%E3%83%93%E3%83%83%E3%83%88%E3%82%B3%E3%82%A4%E3%83%B3%E3%81%A7%E4%BD%95%E3%81%8C%E8%B2%B7%E3%81%88%E3%82%8B%E3%81%AE%E3%81%8B',
    de: '/de/blogs/was-kann-man-mit-bitcoin-im-jahr-2022-kaufen',
  },
  [LINKS.SUPPORT_XRP]: {
    ja: 'https://phemex.com/ja/blogs/%E3%83%AA%E3%83%83%E3%83%97%E3%83%ABxrp%E3%81%A8%E3%81%AF%E4%BD%95%E3%81%A7%E3%81%99%E3%81%8B',
  },
  [LINKS.SUPPORT_SHIBA]: {
    ja: '/ja/academy/%E3%82%B7%E3%83%90%E3%82%A4%E3%83%8C%E3%81%A8%E3%81%AF%E3%83%89%E3%83%BC%E3%82%B8%E3%82%B3%E3%82%A4%E3%83%B3%E3%82%AD%E3%83%A9%E3%83%BC%E3%81%AA%E3%81%AE%E3%82%A4%E3%83%9F%E3%83%86%E3%82%A4%E3%82%BF%E3%83%BC%E3%81%AA%E3%81%AE',
    de: '/de/academy/was-ist-shiba-inu-dogecoin-killer-oder-imitator',
    ru: '/ru/academy/%D0%A7%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-shiba-inu-%D0%A3%D0%B1%D0%B8%D0%B9%D1%86%D0%B0-dogecoin-%D0%B8%D0%BB%D0%B8-%D0%B5%D0%B3%D0%BE-%D0%BF%D0%BE%D0%B4%D1%80%D0%B0%D0%B6%D0%B0%D1%82%D0%B5%D0%BB%D1%8C',
    es: '/es/academy/que-es-shiba-inu',
    fr: '/fr/academy/quest-ce-que-le-shiba-inu-dogecoin-killer-ou-imitateur',
    tr: '/tr/academy/shib-coin-nedir-dogecoin-katili-mi-yoksa-taklitci-mi',
  },
  [LINKS.SUPPORT_DOGECOIN_VS_SHIBA]: {
    de: '/de/academy/dogecoin-vs-shiba-inu-was-ist-besser',
    ru: '/ru/academy/dogecoin-%D0%B2-%D1%81%D1%80%D0%B0%D0%B2%D0%BD%D0%B5%D0%BD%D0%B8%D0%B8-%D1%81-shiba-inu-shib-%D0%A7%D1%82%D0%BE-%D0%BB%D1%83%D1%87%D1%88%D0%B5',
  },
  [LINKS.SUPPORT_ADA]: {
    ja: '/ja/academy/%E3%82%AB%E3%83%AB%E3%83%80%E3%83%8E%E3%81%A8%E3%81%AF%E3%82%B9%E3%83%9E%E3%83%BC%E3%83%88%E3%82%B3%E3%83%B3%E3%83%88%E3%83%A9%E3%82%AF%E3%83%88',
    de: '/de/academy/was-ist-cardano-ada',
    ru: '/ru/academy/%D0%A7%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-cardano-%D0%A1%D0%BC%D0%B0%D1%80%D1%82-%D0%BA%D0%BE%D0%BD%D1%82%D1%80%D0%B0%D0%BA%D1%82',
    es: '/es/academy/que-es-cardano-un-contrato-inteligente',
  },
  [LINKS.SUPPORT_BLOCKCHAIN_TECHNOLOGY]: {
    ja: '/academy/%E3%83%96%E3%83%AD%E3%83%83%E3%82%AF%E3%83%81%E3%82%A7%E3%83%BC%E3%83%B3%E6%8A%80%E8%A1%93%E3%81%A8%E3%81%AF',
    de: '/de/academy/was-ist-die-blockchain-technologie',
    ru: '/ru/academy/%D0%A7%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-%D0%A2%D0%B5%D1%85%D0%BD%D0%BE%D0%BB%D0%BE%D0%B3%D0%B8%D1%8F-%D0%91%D0%BB%D0%BE%D0%BA%D1%87%D0%B5%D0%B9%D0%BD',
    fr: '/fr/academy/quest-ce-que-la-technologie-de-la-blockchain',
    tr: '/tr/academy/what-is-blockchain-technology',
  },
  [LINKS.SUPPORT_BCH]: {
    ja: '/ja/academy/%E3%83%93%E3%83%83%E3%83%88%E3%82%B3%E3%82%A4%E3%83%B3%E3%82%AD%E3%83%A3%E3%83%83%E3%82%B7%E3%83%A5bchbch%E3%81%AF%E6%8A%95%E8%B3%87%E3%81%AB%E9%81%A9%E3%81%97%E3%81%A6%E3%81%84%E3%82%8B%E3%81%8B',
    de: '/de/academy/was-ist-bitcoin-cash',
    ru: '/ru/academy/bitcoin-cash-bch-%D0%AF%D0%B2%D0%BB%D1%8F%D0%B5%D1%82%D1%81%D1%8F-%D0%BB%D0%B8-bch-%D1%85%D0%BE%D1%80%D0%BE%D1%88%D0%B5%D0%B9-%D0%B8%D0%BD%D0%B2%D0%B5%D1%81%D1%82%D0%B8%D1%86%D0%B8%D0%B5%D0%B9',
    tr: '/tr/academy/bitcoin-cash-bch-nedir',
    es: '/es/academy/bitcoin-cash-bch',
  },
  [LINKS.SUPPORT_DOT]: {
    ja: '/ja/academy/what-is-polkadot-coin',
    es: '/es/academy/que-es-polkadot-explicacion-del-token-dot',
  },
  [LINKS.SUPPORT_DENT]: {
    ja: '/ja/academy/dent%E3%81%A8%E3%81%AF%E3%83%A2%E3%83%90%E3%82%A4%E3%83%AB%E3%83%87%E3%83%BC%E3%82%BF%E3%82%92%E5%A3%B2%E8%B2%B7%E3%81%99%E3%82%8B',
    tr: '/tr/academy/dent-exchange-ve-dent-coin-nedir',
  },
  [LINKS.SUPPORT_SOL_VS_ETH]: {},
  [LINKS.SUPPORT_SOL]: {
    es: '/es/academy/solana-infraestructura-abierta-disenada-para-la-adopcion-global',
    de: '/de/academy/was-ist-solana-offene-infrastrukturen-fuer-die-weltweite-einfuehrung',
  },
  [LINKS.SUPPORT_AVAX]: {
    tr: '/tr/academy/avax-coin-nedir-devrimci-bir-mutabakat-protokolu',
  },
  [LINKS.SUPPORT_HEDERA_HASHGRAPH]: {
    ja: '/ja/academy/hedera-hashgraph-hbar%E3%81%A8%E3%81%AF%E9%9D%9E%E4%B8%AD%E5%A4%AE%E9%9B%86%E6%A8%A9%E7%9A%84%E3%81%AA%E5%88%86%E6%95%A3%E5%9E%8B%E5%8F%B0%E5%B8%B3',
    de: '/de/academy/was-ist-solana-offene-infrastrukturen-fuer-die-weltweite-einfuehrung',
  },
  [LINKS.SUPPORT_LRC]: {},
  [LINKS.SUPPORT_MANA]: {
    de: '/de/academy/was-ist-mana-decentraland-die-naechste-generation-der-virtuellen-welten',
    es: '/es/academy/que-es-decentraland-mana',
  },
  [LINKS.SUPPORT_MANA_VS_SAND]: {},
  [LINKS.SUPPORT_TRX]: {
    ja: '/ja/academy/%E3%83%88%E3%83%AD%E3%83%B3trx%E3%81%A8%E3%81%AF',
    ru: '/ru/academy/%D0%A7%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-%D0%A2%D1%80%D0%BE%D0%BD-trx',
    es: '/es/academy/que-es-tron-trx',
    tr: '/tr/academy/tron-trx-nedir',
  },
  [LINKS.SUPPORT_HOW_CRYPTO_RESEARCH]: {},
  [LINKS.SUPPORT_ZEC]: {
    ja: '/ja/academy/%E3%83%97%E3%83%A9%E3%82%A4%E3%83%90%E3%82%B7%E3%83%BC%E3%81%AB%E7%89%B9%E5%8C%96%E3%81%97%E3%81%9F%E6%9A%97%E5%8F%B7%E9%80%9A%E8%B2%A8%E3%82%B8%E3%83%BC%E3%82%AD%E3%83%A3%E3%83%83%E3%82%B7%E3%83%A5zcashzec%E3%81%A8%E3%81%AF',
  },
  [LINKS.SUPPORT_DO_YOUR_OWN_RESEARCH]: {
    ja: '/ja/academy/dyordo-your-own-research%E3%83%BC%E8%87%AA%E5%88%86%E3%81%A7%E8%AA%BF%E3%81%B9%E3%82%8B%E6%96%B9%E6%B3%95%E5%8C%85%E6%8B%AC%E7%9A%84%E3%81%AA%E3%82%AC%E3%82%A4%E3%83%89',
  },
  [LINKS.SUPPORT_MATIC]: {
    de: '/de/blogs/was-ist-polygon-matic-ethereums-internet-der-blockchains',
  },
  [LINKS.SUPPORT_HOW_CRYPTO_RESEARCH]: {},
  [LINKS.SUPPORT_SANDBOX]: {
    ja: '/ja/academy/the-sandbox%E3%82%B6%E3%82%B5%E3%83%B3%E3%83%89%E3%83%9C%E3%83%83%E3%82%AF%E3%82%B9%E3%81%A8%E3%81%AF%E5%85%A8%E3%81%A6%E3%82%92%E6%89%8B%E3%81%AB%E5%85%A5%E3%82%8C%E3%82%8B%E3%81%93%E3%81%A8%E3%81%8C%E3%81%A7%E3%81%8D%E3%82%8B%E3%83%90%E3%83%BC%E3%83%81%E3%83%A3%E3%83%AB%E4%B8%96%E7%95%8C',
    ru: '/ru/academy/%D1%87%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-sandbox-%D0%B2%D0%B8%D1%80%D1%82%D1%83%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BC%D0%B8%D1%80-%D0%B3%D0%B4%D0%B5-%D0%B2%D1%81%D0%B5-%D0%BF%D1%80%D0%B8%D0%BD%D0%B0%D0%B4%D0%BB%D0%B5%D0%B6%D0%B8%D1%82-%D0%B2%D0%B0%D0%BC',
    es: '/es/academy/que-es-sandbox',
    tr: '/tr/academy/sandbox-ve-sand-coin',
  },
  [LINKS.SUPPORT_USDC]: {
    ja: '/ja/academy/usd%E3%82%B3%E3%82%A4%E3%83%B3usdc%E3%81%A8%E3%81%AF',
    ru: '/ru/academy/%D0%A7%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-usd-coin-usdc',
  },
  [LINKS.PHEMEX_HOW_DO_I_MAKE_WITHDRAWAL]: {
    ja: '/ja/help-center/%E5%BC%95%E3%81%8D%E5%87%BA%E3%81%97%E3%82%92%E3%81%99%E3%82%8B%E3%81%AB%E3%81%AF',
    ru: '/ru/help-center/%D0%BA%D0%B0%D0%BA-%D1%81%D0%BD%D1%8F%D1%82%D1%8C-%D1%81%D1%80%D0%B5%D0%B4%D1%81%D1%82%D0%B2%D0%B0-%D1%81%D0%BE-%D1%81%D1%87%D0%B5%D1%82%D0%B0',
    de: '/de/help-center/wie-kann-ich-eine-abhebung-vornehmen',
    es: '/es/help-center/como-realizo-una-retirada-de-fondos',
    fr: '/fr/help-center/comment-puis-je-effectuer-un-retrait',
    tr: '/tr/help-center/how-do-i-make-a-withdrawal',
    pt: '/pt/help-center/como-faco-para-realizar-um-saque',
  },
  [LINKS.PHEMEX_HOW_DO_I_BUY_OR_SELL_COIN]: {
    ja: '/ja/help-center/%E3%82%B3%E3%82%A4%E3%83%B3%E3%82%92%E8%B3%BC%E5%85%A5%E3%81%BE%E3%81%9F%E3%81%AF%E5%A3%B2%E5%8D%B4%E3%81%99%E3%82%8B%E3%81%AB%E3%81%AF%E3%81%A9%E3%81%86%E3%81%99%E3%82%8C%E3%81%B0%E3%82%88%E3%81%84%E3%81%A7%E3%81%99%E3%81%8B%E7%8F%BE%E7%89%A9%E5%8F%96%E5%BC%95',
    ru: '/ru/help-center/%D0%BA%D0%B0%D0%BA-%D0%BA%D1%83%D0%BF%D0%B8%D1%82%D1%8C-%D0%B8%D0%BB%D0%B8-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D1%82%D1%8C-%D0%BC%D0%BE%D0%BD%D0%B5%D1%82%D1%83-%D1%81%D0%BF%D0%BE%D1%82%D0%BE%D0%B2%D0%B0',
    es: '/es/help-center/como-compro-o-vendo-criptomonedas-en-el-mercado-spot-al-contado',
    fr: '/fr/help-center/comment-acheter-ou-vendre-une-crypto-trading-au-comptant',
    tr: '/tr/help-center/how-do-i-buy-or-sell-a-coin-spot-trading',
  },
  [LINKS.SUPPORT_USDC]: {
    ja: '/ja/academy/usd%E3%82%B3%E3%82%A4%E3%83%B3usdc%E3%81%A8%E3%81%AF',
    ru: '/ru/academy/%D0%A7%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-usd-coin-usdc',
  },
  [LINKS.SUPPORT_XLM]: {
    ja: '/ja/academy/%E3%82%B9%E3%83%86%E3%83%A9%E3%83%AB%E3%83%BC%E3%83%A1%E3%83%B3xlm%E3%81%AF%E3%82%88%E3%81%84%E6%8A%95%E8%B3%87%E5%85%88%E3%81%8B',
  },
  [LINKS.SUPPORT_BTC_VS_ETH_VS_LTC]: {},
  [LINKS.SUPPORT_LTC]: {
    ja: '/ja/academy/litecoinltc%E3%81%A8%E3%81%AF%E6%89%8B%E8%BB%BD%E3%81%AA%E3%83%93%E3%83%83%E3%83%88%E3%82%B3%E3%82%A4%E3%83%B3',
    de: '/de/academy/was-ist-litecoin-ltc-eine-leichtgewichtige-version-des-bitcoin',
    ru: '/ru/academy/%D0%A7%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-litecoin-ltc-%D0%BE%D0%B1%D0%BB%D0%B5%D0%B3%D1%87%D0%B5%D0%BD%D0%BD%D0%B0%D1%8F-%D0%B2%D0%B5%D1%80%D1%81%D0%B8%D1%8F-%D0%B1%D0%B8%D1%82%D0%BA%D0%BE%D0%B8%D0%BD%D0%B0',
    es: '/es/academy/que-es-litecoin-ltc',
    tr: '/tr/academy/litecoin-ltc-nedir-bitcoinin-daha-hafif-bir-versiyonu',
  },
  [LINKS.SUPPORT_TRADE_CRYPTO]: {
    ja: '/ja/academy/%E4%BB%AE%E6%83%B3%E9%80%9A%E8%B2%A8%E3%82%92%E5%8F%96%E5%BC%95%E3%81%99%E3%82%8B%E3%81%AB%E3%81%AF%E3%82%B9%E3%83%9D%E3%83%83%E3%83%88%E5%8F%96%E5%BC%95%E3%81%A8%E3%81%AF',
    ru: '/ru/academy/%D0%9A%D0%B0%D0%BA-%D1%82%D0%BE%D1%80%D0%B3%D0%BE%D0%B2%D0%B0%D1%82%D1%8C-%D0%BA%D1%80%D0%B8%D0%BF%D1%82%D0%BE%D0%B2%D0%B0%D0%BB%D1%8E%D1%82%D0%BE%D0%B9',
    fr: '/fr/academy/comment-trader-des-cryptos-le-trading-au-comptant-explique',
  },
  [LINKS.SUPPORT_AVAX]: {
    tr: '/tr/academy/avax-coin-nedir-devrimci-bir-mutabakat-protokolu',
  },
  [LINKS.SUPPORT_SMART_CONTRACTS]: {
    ru: '/ru/academy/%D0%A7%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-ethereum-%D0%A1%D0%BC%D0%B0%D1%80%D1%82-%D0%BA%D0%BE%D0%BD%D1%82%D1%80%D0%B0%D0%BA%D1%82%D1%8B',
    fr: '/fr/academy/quest-ce-que-ethereum-et-les-smart-contracts',
  },
  [LINKS.SUPPORT_XTC]: {
    ja: '/ja/academy/tezos%E3%81%A8%E3%81%AF-tezzies%E3%82%92%E5%AE%89%E5%85%A8%E3%81%AA%E3%82%B9%E3%83%9E%E3%83%BC%E3%83%88%E3%82%B3%E3%83%B3%E3%83%88%E3%83%A9%E3%82%AF%E3%83%88%E3%81%AB',
  },
};
